const isEven = (num: number) => num % 2 === 0

const isOdd = (num: number) => Math.abs(num % 2) === 1

export { isEven, isOdd }
